// extracted by mini-css-extract-plugin
export var bodySections = "_58-8";
export var gray = "_58-7";
export var green = "_58-4";
export var iconContainer = "_58-9";
export var iconWidgetContainer = "_58-1";
export var phoneIcon = "_58-2";
export var red = "_58-5";
export var statusDot = "_58-3";
export var widgetContainer = "_58-0";
export var yellow = "_58-6";